const SendMessage = (msg) => {
  window.parent.postMessage(msg, "*");
};

export default SendMessage;
